import { createContext, useContext } from "react";

import { IMissingDataContext } from "../types";

export const MissingDataContext = createContext<IMissingDataContext | null>(null);

export const useMissingData = () => {
  const context = useContext(MissingDataContext);

  if (!context) {
    throw new Error(
      "You can only use this context inside a MissingDataMultistep component."
    );
  }

  return context;
};
